<div *ngIf="!isEditing && clickToEdit" (click)="startEditing()" class="click-to-edit-area">
    <div>{{ !currentValue || currentValue.length === 0 ? '--' : currentValue.join(',') }}</div>
</div>

<ng-container *ngIf="isEditing || !clickToEdit">
    <nz-checkbox-group [(ngModel)]="checkOptions" (ngModelChange)="updateSingleChecked($event)"></nz-checkbox-group>
    <div class="action-group" *ngIf="!formControlName">
        <button nz-button nzType="primary" class="action-item" (click)="handleSave()" [nzLoading]="saveLoading">Save</button>
        <button nz-button  nzDanger class="action-item" (click)="handleCancel()">Cancel</button>
    </div>
</ng-container>
